module.exports = __webpack_public_path__ + "images/blog/blog_card/questions/13_0a15dac8d12b92b08a0d0c8e37dc16ae.jpg";